import { View, Text, StyleSheet } from 'react-native'

// styles
import { colorPalette, globalStyles } from '../../static/styles/global'
import { boardStyles } from '../../static/styles/board'

interface boardFormCategoryProps {
  title: string
}

const BoardFormCategory = ({ title }: boardFormCategoryProps): JSX.Element => {
  return (
    <View style={[boardStyles.boardCategory]}>
      <Text
        style={[
          globalStyles.text,
          globalStyles.fwBold,
          globalStyles.whiteTextColor
        ]}
      >
        {title}
      </Text>
    </View>
  )
}

export default BoardFormCategory
